// Raw API response from backend (snake_case)
export interface EmailThemeApiResponse {
  appearance: "light";
  css_variables: Record<string, Record<string, string>>;
  custom_colors?: Record<string, string>;
  id: number;
  is_custom: boolean;
  is_default: boolean;
  theme_name: string;
}

// Normalized theme for use in React components (camelCase)
export interface EmailTheme {
  appearance: "light";
  cssVariables: Record<string, Record<string, string>>;
  customColors?: Record<string, string>;
  id: number;
  isCustom: boolean;
  isDefault: boolean;
  name: string;
  value: number; // same as id, used for dropdown selectors
}

// BuilderUI-specific theme structure
export interface BuilderUIEmailTheme {
  cssVariables: Record<string, Record<string, string>>;
  customColors?: Record<string, string>;
  isCustom: boolean;
  name: string;
  value: number;
}

// Payload for updating email theme
export interface UpdateEmailThemePayload {
  appearance?: "light";
  broadcastId: number;
  themeId: number;
}

// Transform functions
export function transformApiToEmailTheme(
  apiTheme: EmailThemeApiResponse,
): EmailTheme {
  return {
    id: apiTheme.id,
    name: apiTheme.theme_name,
    value: apiTheme.id,
    appearance: apiTheme.appearance,
    cssVariables: apiTheme.css_variables,
    isCustom: apiTheme.is_custom,
    isDefault: apiTheme.is_default,
    customColors: apiTheme.custom_colors,
  };
}

export function transformEmailThemeToBuilderUI(
  theme: EmailThemeApiResponse,
): BuilderUIEmailTheme {
  return {
    name: theme.theme_name,
    value: theme.id,
    cssVariables: theme.css_variables,
    isCustom: theme.is_custom,
    customColors: theme.custom_colors,
  };
}
